import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

import { AnalyticsClickDirective, ClickActivateDirective, ClickAreaDirective } from "@directives";
import { TButtonRadius, TButtonSize, TButtonType } from "@models";

import { AbstractStoppableComponent } from "../abstract/abstract-stoppable.component";

@Component({
  selector: "mn-button",
  styleUrls: ["./button.component.scss"],
  templateUrl: "./button.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AnalyticsClickDirective, ClickActivateDirective, ClickAreaDirective],
})
export class ButtonComponent extends AbstractStoppableComponent {
  public disabled = input<boolean>(false);
  public animation = input<boolean>(true);
  public type = input<TButtonType>("default");
  public size = input<TButtonSize>("regular");
  public radius = input<TButtonRadius>("r-12");
  public aEvent = input<string>("");

  public clicked = output<Event>();

  public onClick(event: Event): void {
    if (this.disabled()) {
      return;
    }

    this.clicked.emit(event);
  }
}
